import ApiMethods from '../ApiMethods';
import Endpoints from '../Endpoints';

/**
 * RUTEX User & Employee API Manager Service
 */
export const UserApiManager = {
  /**
   * Fetch consolidated employee catalog options (Roles, Zonas, Jerarquías)
   */
  getEmployeeCatalogs: async () => {
    return await ApiMethods.get(Endpoints.USER_CATALOGS);
  },

  /**
   * Create a new employee with initial inactive status
   * @param {object} employeeData 
   */
  createEmployee: async (employeeData) => {
    return await ApiMethods.post(Endpoints.USERS, employeeData);
  },

  /**
   * Get filtered & paginated list of users
   * @param {object} params (search, rol, status, page, per_page)
   */
  getUsers: async (params = {}) => {
    return await ApiMethods.get(Endpoints.USERS, { params });
  },

  /**
   * Update existing user information
   * @param {string} id 
   * @param {object} userData 
   */
  updateUser: async (id, userData) => {
    return await ApiMethods.put(Endpoints.USER_BY_ID(id), userData);
  },

  /**
   * Toggle status (Activo / Desactivado) of a user
   * @param {string} id 
   * @param {string} status 
   */
  toggleUserStatus: async (id, status) => {
    return await ApiMethods.patch(Endpoints.TOGGLE_USER_STATUS(id), { status });
  },

  /**
   * Get list of sellers for dropdowns
   */
  getSellers: async () => {
    return await ApiMethods.get(Endpoints.SELLERS);
  },

  /**
   * Get list of merchandisers for dropdowns
   */
  getMerchandisers: async () => {
    return await ApiMethods.get(Endpoints.MERCHANDISERS);
  },

  /**
   * Preview operational impact of assigning or changing zone of a user
   * @param {object} payload { user_id, rol, zone_id }
   */
  previewZoneImpact: async (payload) => {
    return await ApiMethods.post(Endpoints.ZONE_IMPACT, payload);
  }
};

export default UserApiManager;
